import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
// content
import Follow from './Follow'
import Ordertake from './Ordertake'
import FamilyInfo from './FamilyInfo'
import Keikai from './Keikai'
import VideoChat from './VideoChat'
import Calendar from './Calendar'
import AppLaunch from './AppLaunch'
import SoundBroadcast from './SoundBroadcast'

export default {
  name: 'ServiceFunctionDetail',
  components: {
    Loading,
    Follow,
    Ordertake,
    FamilyInfo,
    Keikai,
    VideoChat,
    Calendar,
    AppLaunch,
    SoundBroadcast,
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  props: {
    serviceId: String,
    functionId: String
  },
  data () {
    return {
      loading: true,
      processing: false
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.getLinkCategory({
      serviceUuid: this.serviceId
    }).then(res => {
      this.init()
    }).catch(error => {
      this.init()
      this.showError(error || null)
    })
  },
  beforeDestroy() {
    this.reset()
    // リンク集カテゴリリセット
    this.resetLinkCategory()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceFunctionDetail.categoryName,
      functionName: state => state.serviceFunctionDetail.functionName,

      // form
      values: state => state.serviceFunctionDetail.values,
      deliveryType: state => state.serviceFunctionDetail.deliveryType
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      getPermission: 'permission/get'
    }),

    // list
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      showToast: 'toast/show',
      loadModel: 'serviceFunctionDetail/loadModel',
      reset: 'serviceFunctionDetail/reset',
      // リンク集カテゴリ
      getLinkCategory: 'serviceLinkCategory/getLinkCategory',
      resetLinkCategory:'serviceLinkCategory/reset',
    }),

    init () {
      this.loading = true

      //
      let functionParams = {
        serviceUuid: this.serviceId,
        serviceFunctionUuid: this.functionId
      }

      // データ読出し
      this.loadModel({
        functionParams: functionParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
        })
        .catch(error => {
          this.showError(error || null)
        })
    },

    showForm (deliveryTypeCd) {
      return this.deliveryType === deliveryTypeCd
    }
  }
}
